export const currencyOptions = [{ label: "BTC", value: "BTC", unit: "sats" }];
